import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createVNode as _createVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-4" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-star" }, null, -1)
const _hoisted_4 = { class: "col-4" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-bookmark-plus" }, null, -1)
const _hoisted_6 = { class: "col-4" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-database-add" }, null, -1)
const _hoisted_8 = { class: "row p-2" }
const _hoisted_9 = { class: "col-12 text-center" }
const _hoisted_10 = ["src"]
const _hoisted_11 = { class: "row p-2" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "col-3 p-2" }, "Nimi", -1)
const _hoisted_13 = { class: "col-9 p-2" }
const _hoisted_14 = { class: "row p-2" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "col-3 p-2" }, "Triipkood", -1)
const _hoisted_16 = { class: "col-9 p-2" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("h4", null, "Pakkumised", -1)
const _hoisted_18 = ["onClick"]
const _hoisted_19 = { class: "row border-1" }
const _hoisted_20 = { class: "col-3 p-2 text-center" }
const _hoisted_21 = ["src"]
const _hoisted_22 = { class: "col-7 p-2" }
const _hoisted_23 = { key: 0 }
const _hoisted_24 = { class: "col-2 p-2" }
const _hoisted_25 = {
  key: 0,
  style: {"background-color":"lightgrey"}
}
const _hoisted_26 = { class: "col-8" }
const _hoisted_27 = {
  key: 0,
  class: "col-4"
}
const _hoisted_28 = { style: {"width":"100%","height":"250px"} }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("h4", null, "Toote detailid", -1)
const _hoisted_30 = { class: "border-1" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("h6", null, "Kirjeldus", -1)
const _hoisted_32 = {
  class: "p-2",
  style: {"background-color":"lightgrey"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")!
  const _component_l_tile_layer = _resolveComponent("l-tile-layer")!
  const _component_l_tooltip = _resolveComponent("l-tooltip")!
  const _component_l_marker = _resolveComponent("l-marker")!
  const _component_l_map = _resolveComponent("l-map")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.isAuthenticated)
      ? (_openBlock(), _createBlock(_component_Header, {
          key: 0,
          title: "",
          back: "home"
        }))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("button", {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.clickAddReview(_ctx.getProduct().id))),
          class: "small border-0 h-100",
          style: _normalizeStyle({backgroundColor: _ctx.reviewIsActive(_ctx.getProduct().id) ? 'lightgreen' : 'lightgray'})
        }, [
          _hoisted_3,
          _createTextVNode(" uus hinnang ")
        ], 4)
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("button", {
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.addBookmark(_ctx.getProduct().id))),
          class: "small border-0 h-100",
          style: _normalizeStyle({backgroundColor: _ctx.bookmarkIsActive(_ctx.getProduct().id) ? 'lightgreen' : 'lightgray'})
        }, [
          _hoisted_5,
          _createTextVNode(" lisa nimekirja ")
        ], 4)
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("button", {
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.clickAddOffer(_ctx.getProduct().id))),
          class: "small border-0 h-100",
          style: {"background-color":"lightgray"}
        }, [
          _hoisted_7,
          _createTextVNode(" uus pakkumine ")
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("img", {
          src: _ctx.getProductImageByBarcode(_ctx.getProduct().barcode),
          alt: "",
          height: "164"
        }, null, 8, _hoisted_10)
      ])
    ]),
    _createElementVNode("div", _hoisted_11, [
      _hoisted_12,
      _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.getProduct().name), 1)
    ]),
    _createElementVNode("div", _hoisted_14, [
      _hoisted_15,
      _createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.getProduct().barcode), 1)
    ]),
    _hoisted_17,
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getOffersDetails(), (item) => {
      return (_openBlock(), _createElementBlock("div", {
        key: item.id,
        class: "border",
        onClick: ($event: any) => (_ctx.setItemDetails(item.id))
      }, [
        _createElementVNode("div", _hoisted_19, [
          _createElementVNode("div", _hoisted_20, [
            (item.url)
              ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  src: _ctx.getShopImageByType(item.url),
                  alt: "",
                  width: "32",
                  height: "32"
                }, null, 8, _hoisted_21))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_22, [
            _createElementVNode("div", null, _toDisplayString(item.name), 1),
            (this.identityStore.getCoords().latitude)
              ? (_openBlock(), _createElementBlock("div", _hoisted_23, _toDisplayString(_ctx.distanceUtil.round(
                            _ctx.distanceUtil.calculateDistance(
                                this.identityStore.getCoords().latitude,
                                this.identityStore.getCoords().longitude,
                                item.latitude, item.longitude))) + "km ", 1))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_24, " €" + _toDisplayString(item.offers.sort((a, b) => a.price.amount - b.price.amount)[0].price.amount), 1)
        ]),
        (_ctx.showItemDetails(item.id))
          ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.offers, (subItem) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "row border-bottom-1",
                  key: subItem.id
                }, [
                  _createElementVNode("div", _hoisted_26, [
                    _createElementVNode("div", null, "Toote nimi: " + _toDisplayString(subItem.name), 1),
                    _createElementVNode("div", null, "Lisatud: " + _toDisplayString(subItem.addedBy), 1)
                  ]),
                  (subItem.price.amount)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_27, " €" + _toDisplayString(subItem.price.amount), 1))
                    : _createCommentVNode("", true)
                ]))
              }), 128))
            ]))
          : _createCommentVNode("", true)
      ], 8, _hoisted_18))
    }), 128)),
    _createElementVNode("div", _hoisted_28, [
      _createVNode(_component_l_map, {
        modelValue: _ctx.zoom,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.zoom) = $event)),
        zoom: _ctx.zoom,
        "onUpdate:zoom": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.zoom) = $event)),
        center: [59.436962, 24.753574],
        onMove: _cache[5] || (_cache[5] = ($event: any) => (_ctx.log('move')))
      }, {
        default: _withCtx(() => [
          _createVNode(_component_l_tile_layer, { url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" }),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getOffersDetails(), (item) => {
            return (_openBlock(), _createBlock(_component_l_marker, {
              "lat-lng": [item.latitude, item.longitude],
              key: item.id
            }, {
              default: _withCtx(() => [
                _createVNode(_component_l_tooltip, null, {
                  default: _withCtx(() => [
                    _createTextVNode(" €" + _toDisplayString(item.name), 1)
                  ]),
                  _: 2
                }, 1024)
              ]),
              _: 2
            }, 1032, ["lat-lng"]))
          }), 128))
        ]),
        _: 1
      }, 8, ["modelValue", "zoom", "center"])
    ]),
    _hoisted_29,
    _createElementVNode("div", _hoisted_30, [
      _hoisted_31,
      _createElementVNode("div", _hoisted_32, _toDisplayString(_ctx.getProduct().description), 1)
    ])
  ], 64))
}